import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "home-toolbar" }
const _hoisted_3 = { class: "stats-grid" }
const _hoisted_4 = { class: "stat-card" }
const _hoisted_5 = { class: "stat-number" }
const _hoisted_6 = { class: "stat-card" }
const _hoisted_7 = { class: "stat-number" }
const _hoisted_8 = { class: "stat-card" }
const _hoisted_9 = { class: "stat-number" }
const _hoisted_10 = { class: "stat-card" }
const _hoisted_11 = { class: "stat-value muted" }
const _hoisted_12 = { class: "panels-grid" }
const _hoisted_13 = { class: "panel-card" }
const _hoisted_14 = { class: "panel-head" }
const _hoisted_15 = { class: "panel-caption" }
const _hoisted_16 = { class: "bar-track" }
const _hoisted_17 = { class: "legend-row" }
const _hoisted_18 = { class: "panel-card" }
const _hoisted_19 = { class: "metric-row" }
const _hoisted_20 = { class: "meter" }
const _hoisted_21 = { class: "metric-row" }
const _hoisted_22 = { class: "meter" }
const _hoisted_23 = { class: "insights-grid" }
const _hoisted_24 = { class: "list-grid" }
const _hoisted_25 = { class: "row-title" }
const _hoisted_26 = { class: "row-subtitle" }
const _hoisted_27 = { class: "list-grid" }
const _hoisted_28 = { class: "row-title" }
const _hoisted_29 = { class: "row-subtitle" }
const _hoisted_30 = { class: "days-filter" }
const _hoisted_31 = { class: "list-grid" }
const _hoisted_32 = { class: "row-title" }
const _hoisted_33 = { class: "row-subtitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MonthYearFilter = _resolveComponent("MonthYearFilter")!
  const _component_InsightListCard = _resolveComponent("InsightListCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_MonthYearFilter, {
        modelValue: _ctx.selectedPeriod,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedPeriod) = $event)),
        label: "Visão geral por período"
      }, null, 8, ["modelValue"]),
      _createElementVNode("button", {
        type: "button",
        class: "visibility-btn",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleValuesVisibility && _ctx.toggleValuesVisibility(...args)))
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(_ctx.hideValues ? 'fas fa-eye-slash' : 'fas fa-eye')
        }, null, 2),
        _createElementVNode("span", null, _toDisplayString(_ctx.hideValues ? 'Mostrar valores' : 'Ocultar valores'), 1)
      ])
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("article", _hoisted_4, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "stat-header" }, [
          _createElementVNode("span", { class: "stat-label" }, "Parcelas Pendentes"),
          _createElementVNode("i", { class: "fas fa-clock" })
        ], -1)),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.honorariosPendentes.length), 1),
        _createElementVNode("p", {
          class: _normalizeClass(["stat-value", { blurred: _ctx.hideValues }])
        }, _toDisplayString(_ctx.formatMoney(_ctx.totalPendente)), 3)
      ]),
      _createElementVNode("article", _hoisted_6, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "stat-header" }, [
          _createElementVNode("span", { class: "stat-label" }, "Parcelas Pagas"),
          _createElementVNode("i", { class: "fas fa-check-circle" })
        ], -1)),
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.honorariosPagos.length), 1),
        _createElementVNode("p", {
          class: _normalizeClass(["stat-value", { blurred: _ctx.hideValues }])
        }, _toDisplayString(_ctx.formatMoney(_ctx.totalRecebido)), 3)
      ]),
      _createElementVNode("article", _hoisted_8, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "stat-header" }, [
          _createElementVNode("span", { class: "stat-label" }, "Total de Clientes"),
          _createElementVNode("i", { class: "fas fa-users" })
        ], -1)),
        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.totalClientes), 1),
        _cache[6] || (_cache[6] = _createElementVNode("p", { class: "stat-value muted" }, "Carteira ativa", -1))
      ]),
      _createElementVNode("article", _hoisted_10, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "stat-header" }, [
          _createElementVNode("span", { class: "stat-label" }, "Total Geral"),
          _createElementVNode("i", { class: "fas fa-chart-line" })
        ], -1)),
        _createElementVNode("p", {
          class: _normalizeClass(["stat-number", { blurred: _ctx.hideValues }])
        }, _toDisplayString(_ctx.formatMoney(_ctx.totalGeral)), 3),
        _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.selectedPeriodLabel), 1)
      ])
    ]),
    _createElementVNode("section", _hoisted_12, [
      _createElementVNode("article", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _cache[8] || (_cache[8] = _createElementVNode("h3", null, "Status das Parcelas", -1)),
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.selectedPeriodLabel), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", {
            class: "bar-segment pending",
            style: _normalizeStyle({ width: _ctx.pendingPercentage + '%' })
          }, null, 4),
          _createElementVNode("div", {
            class: "bar-segment paid",
            style: _normalizeStyle({ width: _ctx.paidPercentage + '%' })
          }, null, 4)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("span", null, [
            _cache[9] || (_cache[9] = _createElementVNode("i", { class: "dot pending" }, null, -1)),
            _createTextVNode("Pendentes: " + _toDisplayString(_ctx.honorariosPendentes.length), 1)
          ]),
          _createElementVNode("span", null, [
            _cache[10] || (_cache[10] = _createElementVNode("i", { class: "dot paid" }, null, -1)),
            _createTextVNode("Pagos: " + _toDisplayString(_ctx.honorariosPagos.length), 1)
          ])
        ])
      ]),
      _createElementVNode("article", _hoisted_18, [
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "panel-head" }, [
          _createElementVNode("h3", null, "Distribuição de Valores"),
          _createElementVNode("span", { class: "panel-caption" }, "Por vencimento")
        ], -1)),
        _createElementVNode("div", _hoisted_19, [
          _cache[11] || (_cache[11] = _createElementVNode("span", null, "Pendente", -1)),
          _createElementVNode("strong", {
            class: _normalizeClass({ blurred: _ctx.hideValues })
          }, _toDisplayString(_ctx.formatMoney(_ctx.totalPendente)), 3)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", {
            class: "meter-fill pending",
            style: _normalizeStyle({ width: _ctx.pendingValuePercentage + '%' })
          }, null, 4)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _cache[12] || (_cache[12] = _createElementVNode("span", null, "Recebido", -1)),
          _createElementVNode("strong", {
            class: _normalizeClass({ blurred: _ctx.hideValues })
          }, _toDisplayString(_ctx.formatMoney(_ctx.totalRecebido)), 3)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", {
            class: "meter-fill paid",
            style: _normalizeStyle({ width: _ctx.paidValuePercentage + '%' })
          }, null, 4)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_23, [
      _createVNode(_component_InsightListCard, {
        title: "Clientes com maior atraso",
        description: "Ordenado pelo maior saldo em atraso. Considera o vencimento de cada parcela.",
        "is-empty": !_ctx.clientesEmAtraso.length,
        "empty-text": "Nenhum cliente com parcela em atraso neste periodo."
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_24, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clientesEmAtraso, (cliente) => {
              return (_openBlock(), _createElementBlock("article", {
                key: cliente.customerId,
                class: "list-row"
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_25, _toDisplayString(cliente.customerName), 1),
                  _createElementVNode("p", _hoisted_26, _toDisplayString(cliente.overdueInstallments) + " parcela(s) em atraso", 1)
                ]),
                _createElementVNode("strong", {
                  class: _normalizeClass(["row-value negative", { blurred: _ctx.hideValues }])
                }, _toDisplayString(_ctx.formatMoney(cliente.totalOverdue)), 3)
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["is-empty"]),
      _createVNode(_component_InsightListCard, {
        title: "Maiores clientes",
        description: "Ranking por valor total ja recebido no periodo selecionado.",
        "is-empty": !_ctx.maioresClientes.length,
        "empty-text": "Nenhum pagamento registrado para montar o ranking."
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_27, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.maioresClientes, (cliente) => {
              return (_openBlock(), _createElementBlock("article", {
                key: cliente.customerId,
                class: "list-row"
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_28, _toDisplayString(cliente.customerName), 1),
                  _createElementVNode("p", _hoisted_29, _toDisplayString(cliente.receivedCount) + " parcela(s) recebidas", 1)
                ]),
                _createElementVNode("strong", {
                  class: _normalizeClass(["row-value", { blurred: _ctx.hideValues }])
                }, _toDisplayString(_ctx.formatMoney(cliente.totalPaid)), 3)
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["is-empty"]),
      _createVNode(_component_InsightListCard, {
        title: "Parcelas prestes a vencer",
        description: `Parcelas pendentes com vencimento nos proximos ${_ctx.daysAhead} dias.`,
        "is-empty": !_ctx.honorariosPrestesAVencer.length,
        "empty-text": "Nenhuma parcela prestes a vencer neste recorte."
      }, {
        actions: _withCtx(() => [
          _createElementVNode("label", _hoisted_30, [
            _cache[14] || (_cache[14] = _createElementVNode("span", null, "Janela", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.daysAhead) = $event)),
              type: "number",
              min: "1",
              max: "60",
              class: "days-input"
            }, null, 512), [
              [
                _vModelText,
                _ctx.daysAhead,
                void 0,
                { number: true }
              ]
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_31, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.honorariosPrestesAVencer, (honorario) => {
              return (_openBlock(), _createElementBlock("article", {
                key: honorario.id,
                class: "list-row"
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_32, _toDisplayString(honorario.customerName), 1),
                  _createElementVNode("p", _hoisted_33, "Vence em " + _toDisplayString(honorario.dueDateLabel), 1)
                ]),
                _createElementVNode("strong", {
                  class: _normalizeClass(["row-value", { blurred: _ctx.hideValues }])
                }, _toDisplayString(_ctx.formatMoney(honorario.value)), 3)
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["description", "is-empty"])
    ])
  ]))
}